var exports = {
  "n": "xcc377c0b--4b50f3--link",
  "U": "xcc377c0b--4b50f3--arrow",
};

module.exports = exports;
